import {szBankStorage} from '../../../util/Function/szBankStorage.js'
export function getdata() {
	var obj = {
		searchdata: {
			nsrmc: "",
			year: szBankStorage.$getNowYear(),
			project: "",
			cycle: ""
		},
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "select",
				selectval:szBankStorage.$getdemoCompany
			},
			{
				prop: "year",
				label: '年度',
				type: "select",
				selectval:szBankStorage.$getYearList()
			},
			{
				prop: "project",
				label: '项目',
				type: "select",
				selectval:[
					{
						value:'全部',
						lebal:'全部'
						
					},
					...szBankStorage.$title2_select,
					...szBankStorage.$title1_select,
					...szBankStorage.$title3_select,
					...szBankStorage.$title4_select,
					...szBankStorage.$title5_select,
					...szBankStorage.$title6_select,
					...szBankStorage.$title7_select,
					...szBankStorage.$title8_select,
					
				]
				
			},
			{
				prop: "cycle",
				label: '周期',
				type: "select",
				selectval: szBankStorage.$cyclelist
			},
			{
				prop: "shuikssq",
				label: '税款所属期起止',
				type: "date",
				valueformat:"yyyyMMdd"
			},
		],
		tableData: [{
				project: '一、资产固定（合计）',
				projectT:true,
				select:'$title2_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			}, {
				project: '其中:享受固定资产加速折旧及一次性扣除政策的资产加速折旧额大于一般折旧额的部分受固定资产加速折旧及一次性扣除政策的资产加速折旧额大于一般折旧额的部分',
				projectT:true,
				setproject:true,
				select:'$title1_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '二、生产性生物资产',
				projectT:true,
				select:'$title3_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '三、无形资产(合计)',
				projectT:true,
				select:'$title4_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '其中:享受无形资产加速摊销及一次性摊销政策的资产加速摊销额大于一般摊销额的部分',
				projectT:true,
				setproject:true,
				select:'$title5_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '四、长期待摊费用(合计)',
				projectT:true,
				select:'$title6_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '五、油气勘探投资(合计)',
				projectT:true,
				select:'$title7_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '六、油气开发投资(合计)',
				projectT:true,
				select:'$title8_select',
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '合计',
				projectT:true,
				heji:true,
				SelfSOV:0,
				AmountA:0,
				DepreciationY:0,
				AccumulatedD:0,
				AccumulatedDe:0,
				AssetTax:0,
				TaxDepreciation:0,
				acceleratedDP:0,
				AcceleratedD:0,
				AccumulatedDe:0,
				TaxAA:0,
			},
			{
				project: '全民所有制企业公司制改制资产评估增值政策资产',
				Serial:'附列资料',
				fulie:true,
				projectFor:true,
				ProjectD:'',
				cycle:'',
				shuikssqq:'',
				shuikssqz:'',
				AmountC:'',
				TaxAmount:'',
				IncreaseA:'',
				DecreaseA:'',
				prop1:'',
				prop2:'',
				prop3:'',
				updata:false,
			}
		],
		headData: [{
				title: "序号",
				prop: "Serial",
				custom: true,
				width: 60,
				align: "left"
			},
			{
				title: "项目",
				prop: "project",
				width: '210px',
				custom: true
			},
			{
				title: "项目详情",
				prop: "ProjectD",
				width: 130,
				custom: true,
			},
			{
				title: "周期",
				prop: "cycle",
				custom: true,
				width: 80,
			},
			{
				title: '账载金额',
				children: [{
					title: "数款所属期起",
					prop: "shuikssqq",
					width: 110,
					custom: true
				}, {
					title: "税款所属期止",
					prop: "shuikssqz",
					width: 110,
					custom: true
				}, {
					title: "资产原值	",
					children: [{
						title: "1",
						prop: "AmountA",
						custom: true,
						width: 110,
					}]
				}, {
					title: "本年折旧、摊销额",
					children: [{
						title: "2",
						prop: "DepreciationY",
						custom: true,
						width: 110,
					}]
				}, {
					title: "累计折旧、摊销额",
					children: [{
						title: "3",
						prop: "AccumulatedD",
						custom: true,
						width: 110,
					}]
				}]
			},
			{
				title: '税收金额',
				children: [{
					title: "资产计税 基础",
					children: [{
						title: "4",
						prop: "AssetTax",
						custom: true,
						width: 110,
					}]
				}, {
					title: "税收折旧、摊销额",
					children: [{
						title: "5",
						prop: "TaxDepreciation",
						custom: true,
						width: 110,
					}]
				}, {
					title: "享受加速折旧政策的 资产按税收一般规定 计算的折旧、摊销额",
					children: [{
						title: "6",
						prop: "acceleratedDP",
						custom: true,
						width: 110,
					}]
				}, {
					title: "加速折旧、摊销统计额",
					children: [{
						title: "7",
						prop: "AcceleratedD",
						custom: true,
						width: 110,
					}]
				}, {
					title: "累计折旧、摊销额",
					children: [{
						title: "8",
						prop: "AccumulatedDe",
						custom: true,
						width: 110,
					}]
				}, {
					title: "纳税调整金额",
					children: [{
						title: "9",
						prop: "TaxAA",
						custom: true,
						width: 110,
					}]
				}]
			}, {
				title: "扩展字段1",
				prop: "prop1",
				custom: true,
				width: 110,
			}, {
				title: "扩展字段2",
				prop: "prop2",
				custom: true,
				width: 110,
			}, {
				title: "扩展字段3",
				prop: "prop3",
				custom: true,
				width: 110,
			}, {
				title: "操作",
				prop: "cz",
				width: "150",
				custom: true,
				fixed:"right"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
